var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{attrs:{"cellspacing":"1","cellpadding":"8"}},[_c('thead',[_c('tr',_vm._l((_vm.th),function(r){return _c('td',{key:r},[_vm._v(_vm._s(r))])}),0)]),_c('tbody',_vm._l((_vm.data),function(item,index1){return _c('tr',{key:index1},_vm._l((item),function(d,index2){return _c('td',{key:index2},[_vm._v(_vm._s(_vm._f("decimal")(d)))])}),0)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }